import React from 'react';
import { MainLayout } from '@/components/MainLayout';
import { SupplierPage } from '@/components/registers/Supplier';

export default function SuppliersPage() {
  return (
    <MainLayout>
      <SupplierPage />
    </MainLayout>
  );
}